import {
  GET_FIXTURES_REQUEST,
  GET_FIXTURES_SUCCESS,
  GET_FIXTURES_FAILURE,
  RESET_MATCH_CARD
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_FIXTURES_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_FIXTURES_SUCCESS:
      return {
        data: {
          ...action.payload,
          hasPrevious: !!action.payload.previous,
          hasNext: !!action.payload.next
        }, isLoading: false, error: null
      };
    case GET_FIXTURES_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case RESET_MATCH_CARD:
      return { ...initialState };

    default:
      return state;
  }
};
